import { combineReducers, createStore, compose, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import dashboard from './dashboard'

const reducers = combineReducers({
  dashboard
})

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
const enhancers = composeEnhancers(applyMiddleware(thunk))

export default createStore(reducers, enhancers)



// WEBPACK FOOTER //
// ./src/redux/index.js